<script>
	export let style = "";

	import modal from "../../stores/modal.js";

	import { fade } from "svelte/transition";
	import { backOut, sineIn } from "svelte/easing";

	const effectIn = () => {
		return {
			duration: 400,
			css: (t) => {
				const eased = backOut(t);
				return `
					transform:translateY(${60 * (1 - eased)}px);`;
			},
		};
	};

	const effectOut = () => {
		const rot = Math.random() * 160 - 80;
		return {
			duration: 400,
			css: (t) => {
				const e = sineIn(t);
				return `
					transform:translateY(${400 * (1 - e)}px) rotate(${rot * (1 - e)}deg);`;
			},
		};
	};

	// $: {
	// 	console.log("$modal", $modal);
	// }
</script>

{#if $modal.visible}
	<div
		class="Modal"
		in:fade={{ duration: 100 }}
		out:fade={{ duration: 100, delay: 100 }}
		{style}
	>
		<div class="Modal-box" in:effectIn out:effectOut>
			<p class="Modal-message">{$modal.message}</p>
			<nav>
				{#each $modal.labels as label, index}
					<button
						on:click={() => {
							modal.close(index);
						}}>{label}</button
					>
				{/each}
			</nav>
		</div>
	</div>
{/if}

<style global>
	.Modal {
		width: 100%;
		height: 100%;
		position: fixed;

		padding: 1.5em;
		display: flex;
		align-items: center;
		justify-content: center;
		background: rgba(0, 0, 0, 0.5);
		z-index: 9;
	}
	.Modal-box {
		border-radius: 5px;
		width: 100%;
		max-width: 340px;
		text-align: center;
		background: #fff;
		color: #000;
		overflow: hidden;
	}
	.Modal-message {
		padding: 2em 1em;
	}
	.Modal nav {
		display: flex;
		border-top: 1px solid #eee;
	}
	.Modal button {
		width: 100%;
		transition: background 100ms linear;
		line-height: 1.2;
		padding: 1.25em 1em;
		text-align: center;
		cursor: pointer;
	}
	.Modal button:hover {
		background: #f6f6f6;
	}
</style>
